import React from "react";

const About = () => {
  return (
    <React.Fragment>
      <h1> About Github Finder</h1>
      <p> This is an app to search for Github users.</p>
      <p> Version: 1.0.0</p>
    </React.Fragment>
  );
};

export default About;
